import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';
import type { Query } from 'graphql-models';
import shipmentsQuery from 'walden-fast/graphql/shipments/all-shipments.graphql';
import type BoxApiService from 'walden-fast/services/box-api';
import type UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenBoxMapModel = Resolved<
  ReturnType<AppServicesWaldenBoxMapRoute['model']>
>;

interface QueryParams {
  search?: string;
}

export default class AppServicesWaldenBoxMapRoute extends Route {
  @service('box-api') declare boxApiService: BoxApiService;
  @service('user') declare userService: UserService;

  queryParams = {
    search: { refreshModel: true },
  };

  model({ search }: QueryParams) {
    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_BOX,
    );
    if (userCanAccessService) {
      void this.fetchShipments.perform({
        search,
      });
    }
    return this.fetchShipments;
  }

  fetchShipments = restartableTask(async (params: QueryParams) => {
    const data = await this.boxApiService.query<{
      shipmentsForShipper: Query['shipmentsForShipper'];
    }>({
      query: shipmentsQuery,
      variables: {
        filter: {
          search: params.search,
          shipmentType: 'BOX',
        },
      },
    });

    return data.shipmentsForShipper.data;
  });
}
